import React, { FC } from 'react';
import { View, Text } from 'react-native';
import { UseTableColumnsParams } from '@v2/pages/common/components/NCFileBatchEvents/types';
import { font as initialFont } from '@styles/fonts';
import { EventStatusSubStatusExecModeProps } from '@v2/pages/common/components/NCFileBatchEvents/components/EventStatusSubStatusExecMode';

export interface VersionCellProps extends Pick<UseTableColumnsParams, 'C' | 'font' | 'scale'>, Pick<EventStatusSubStatusExecModeProps, 'event'> {}

const VersionCell: FC<VersionCellProps> = ({ event, C, font = initialFont }) => {
  const ncFileVersionData = event?.ncFileVersionSequenceNumbers || event?.ncFileVersionSequenceNumber;
  const ncFileVersion = ncFileVersionData == null ? null : Array.isArray(ncFileVersionData) ? ncFileVersionData[0] : ncFileVersionData;

  if (ncFileVersion == null) return null;

  return (
    <View>
      <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>v{ncFileVersion}</Text>
    </View>
  );
};

export default React.memo(VersionCell, (prev, next) => {
  return prev.event.sequenceNumber === next.event.sequenceNumber && prev.C.scheme === next.C.scheme;
});
